import Button from "components/button";

import type { FaqSection } from "./types";

const salesDealersSection: FaqSection = {
  id: "sales-dealers",
  title: "Sales Dealers",
  faqs: [
    {
      question: "What is a Sales Dealer in the residential solar industry?",
      answer: (
        <p>
          A Sales Dealer sells solar systems directly to homeowners but relies on external installation partners to
          complete projects. Enerflo optimizes{" "}
          <Button href="/features/sales-process" variant="link">
            Sales Dealer workflows
          </Button>{" "}
          with lead capture, AI-driven solar designs, instant financing options, and digital contract signing, all in
          one platform.
        </p>
      ),
    },
    {
      question: "How does Enerflo help Sales Dealers close more deals?",
      answer: (
        <p>
          Enerflo eliminates tool-switching by integrating solar proposal software,{" "}
          <Button href="/features/lendflo" variant="link">
            financing
          </Button>{" "}
          tools, and contract management in a single system. Features like Smart Pulls (soft credit checks with lender
          recommendations) and Title Checks prevent errors and speed up the sales cycle. In addition, it standardizes
          the sales process across installers and regions to simplify rep training and have the entire deal pipeline in
          one place.
        </p>
      ),
    },
    {
      question: "Can Sales Dealers manage multiple installation partners within Enerflo?",
      answer: (
        <p>
          Yes. Enerflo supports multi-organization workflows, letting Sales Dealers manage multiple installer
          relationships with unique pricing, proposals, and project handoffs — all from one dashboard.
        </p>
      ),
    },
    {
      question: "Does Enerflo integrate with CRMs?",
      answer: (
        <p>
          Yes. Enerflo integrates with Salesforce, Zoho, HubSpot, and more. Sales Dealers can connect Enerflo to their
          CRM or use Enerflo as their primary CRM.
        </p>
      ),
    },
    {
      question: "What financing options are available for Sales Dealers?",
      answer: (
        <p>
          Enerflo integrates with top solar lenders to provide loan, lease and PPA and escrow (for cash deals) options
          directly within proposals. Smart Pulls recommends the financing options most likely to be approved.
        </p>
      ),
    },
    {
      question: "Can Sales Dealers track installation progress?",
      answer: (
        <p>
          Yes. Even without performing installations, Sales Dealers can view real-time project milestones in Install
          Tracker to improve homeowner communication.
        </p>
      ),
    },
  ],
};

export default salesDealersSection;
